import React, { useContext } from 'react';
import { Button, Expandable, Modal } from '@warp-ds/react';
import { PageProps } from '../page.js';
import { onDeleteUser, onDeleteUserPopup } from '../consent-tracking.js';
import Profile from './profile.js';
import TranslationContext from '../translation-context.js';
import { Trans, useLingui } from '@lingui/react';

export default function Consents({
    consentUser,
    profile,
    hmacToken,
}: PageProps): React.ReactElement {
    const { i18n } = useLingui();
    const { texts } = useContext(TranslationContext);

    const [open, setOpen] = React.useState(false);
    const toggleModal = () => {
        setOpen(!open);

        if (!open) {
            onDeleteUserPopup();
        }
    };
    if (consentUser.isLoggedIn) {
        return (
            <div className="my-32 s-border border-1 rounded-8 s-bg-info-subtle p-16">
                <Expandable
                    title={
                        <span className="t4">
                            <Trans
                                id="privacy-settings.delete.header"
                                values={texts}
                            />
                        </span>
                    }
                    animated
                    buttonClass="w-full"
                    contentClass="mt-12"
                >
                    <div>
                        <p className="text-s">
                            <Trans
                                id="privacy-settings.delete.paragraph"
                                values={texts}
                            />
                        </p>
                        <Button negative small onClick={toggleModal}>
                            <Trans
                                id="privacy-settings.delete.button"
                                values={texts}
                            />
                        </Button>
                    </div>
                    <Modal
                        open={open}
                        title={i18n.t({
                            id: 'privacy-settings.delete.modal.header',
                            comment: 'Delete account modal header',
                            values: texts,
                        })}
                        footer={
                            <>
                                <Button
                                    secondary
                                    quiet
                                    onClick={toggleModal}
                                    className="mr-8"
                                >
                                    <Trans
                                        id="privacy-settings.delete.modal.cancel"
                                        values={texts}
                                    />
                                </Button>

                                <form
                                    action="/privacy/bruker/slett"
                                    method="post"
                                    onSubmit={onDeleteUser}
                                >
                                    <input
                                        type="hidden"
                                        name="hmacToken"
                                        value={hmacToken}
                                    />

                                    <Button negative type="submit">
                                        <Trans
                                            id="privacy-settings.delete.modal.confirm"
                                            values={texts}
                                        />
                                    </Button>
                                </form>
                            </>
                        }
                    >
                        <p>
                            <Trans
                                id="privacy-settings.delete.modal.text"
                                values={texts}
                            />
                        </p>
                        <Profile profile={profile} />
                    </Modal>
                </Expandable>
            </div>
        );
    } else {
        return <></>;
    }
}
